module.exports = __webpack_public_path__ + "static/media/seguradora_fairfax.f03dd8cd.png";